import { formatCPFOrCNPJ } from 'src/app/helpers/utils/cpf-cnpj.util';
import { CarbonCredit } from 'src/app/shared/interfaces/carbon-credit';
import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';
import { OperationType } from 'src/app/shared/interfaces/operation-type.enum';

export interface OperationTransferDetailsView {
  holderComitente: string;
  purchaserAccount: string;
  purchaserComitente: string;
}

export function isB3TransferOperation(operation: CarbonOperation): boolean {
  return operation.rawTypeCode === OperationType.TRANSFER_WITHOUT_FINANCIAL;
}

export function mapTransferDetailsToView(
  operation: CarbonOperation,
  carbonCredit?: CarbonCredit | null,
): OperationTransferDetailsView {
  const holderComitenteDocument =
    carbonCredit?.comitenteDocumentNumber?.trim() ||
    operation.cpfCnpjComitente?.trim() ||
    operation.investor?.documentNumber?.trim() ||
    '';

  const purchaserComitenteDocument =
    carbonCredit?.purchaserComitenteDocumentNumber?.trim() ||
    operation.purchaserComitenteDocument?.trim() ||
    '';

  return {
    holderComitente: formatTransferComitente(holderComitenteDocument),
    purchaserAccount: displayTransferValue(operation.purchaserCode),
    purchaserComitente: formatTransferComitente(purchaserComitenteDocument),
  };
}

function formatTransferComitente(value?: string | null): string {
  if (!value?.trim()) {
    return '-';
  }

  return formatCPFOrCNPJ(value) ?? value.trim();
}

function displayTransferValue(value?: string | null): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : '-';
}
